import type { ChannelEncryptionKind } from '~/generated/graphql';
import { i18n } from '~/lib/i18n';

export const formatEncryption = (value: ChannelEncryptionKind | null | undefined) =>
  value && value !== 'NONE' ? i18n.t(`pages.channels.encryption_types.${value}`) : '--';
